import React from "react";
import styles from "../svgs.module.scss";
import classNames from "classnames";

const IconsCircleBorder = React.memo(({ children, border, style, ...rest }) => {
    const customStyle = { ...style };
    let borderColor = null;
    if (border > 0) {
        customStyle.borderWidth = border;
    }
    React.Children.map(children, child => {
        if (!React.isValidElement(child)) {
            return child;
        }

        if (child.props?.color) {
            borderColor = child.props?.color;
        }
    });

    return <div
        className={classNames(styles["circle-border-icon"], { [styles[borderColor]]: borderColor })}
        style={customStyle} {...rest}>
        {children}
    </div>;
});

export default IconsCircleBorder;